import React, { useState } from 'react';
import { NavBarItem } from '../navBar/navBarItem';
import NavigationItem from './NavigationItem';
import Menu from '../../../global/Menu/Menu';
import NavigationDropdown from './NavigationDropdown';
import { NavigationItemWrapper, Wrapper } from './DesktopNavigation.style';

interface DesktopNavigationProps {
  navBarItems: NavBarItem[];
  onClickNavigationItem: (navigationItemKey: string) => void;
}

const DesktopNavigation: React.FC<DesktopNavigationProps> = ({
  navBarItems,
  onClickNavigationItem,
}) => {
  const [activeMenu, setActiveMenu] = useState<string[]>([]);
  return (
    <Wrapper>
      {navBarItems.map((navBarItem) => {
        if (navBarItem.items?.length) {
          return (
            <NavigationItemWrapper key={navBarItem.key}>
              <Menu
                label={
                  <NavigationItem
                    label={navBarItem.title}
                    link={navBarItem.customLink}
                    isActive={activeMenu.includes(navBarItem.key)}
                    onClick={() => {
                      onClickNavigationItem(navBarItem.key);
                    }}
                  />
                }
                onToggleMenuDropdown={(isShow) =>
                  setActiveMenu((activeMenu) =>
                    isShow
                      ? [...activeMenu, navBarItem.key]
                      : activeMenu.filter((key) => key !== navBarItem.key),
                  )
                }
                menuDropdown={
                  <NavigationDropdown>
                    {navBarItem.items.map((dropdownItem) => (
                      <NavigationDropdown.Item
                        key={dropdownItem.key}
                        label={dropdownItem.title}
                        link={dropdownItem.customLink}
                        onClick={() => {
                          onClickNavigationItem(dropdownItem.key);
                        }}
                      />
                    ))}
                  </NavigationDropdown>
                }
              />
            </NavigationItemWrapper>
          );
        }

        return (
          <NavigationItemWrapper
            key={navBarItem.key}
            data-test="desktop-nav-item"
          >
            <NavigationItem
              label={navBarItem.title}
              link={navBarItem.customLink}
              onClick={() => {
                onClickNavigationItem(navBarItem.key);
              }}
            />
          </NavigationItemWrapper>
        );
      })}
    </Wrapper>
  );
};

export default DesktopNavigation;
